import React from "react";
import "./ServicesPage.css";

export function ServicesPage() {
    return <div>Services Page </div>;
}
